export class MachineGroupFilters {
  name: string;
  serialNumbers: string[];
}
